import React from 'react';

const Results = ({
  onClick,
  failed,
  completed,
  quizResult,
  webinar
}) => (
  <div>
    <div className="modal-content">
      <p className="test_text_question">
        {failed && `You scored ${quizResult} out of 10. You require a score of 8 out of 10 to pass the quiz. Please try again.`}
        {completed && `${webinar.webinar_title} completed successfully. You scored ${quizResult} out of 10. ${webinar.cpd_status === 'applied_for' ? ' This module is awaiting approval from the ICGP. As soon as CPD is granted, you will be notified that your CPD Cert has been added to your CPD Locker for download.': ' Your CPD Cert added to your CPD Locker for download.' }`}

      </p>
      <div className="submit_center col s12">
        <input
          className="test_submit"
          type="submit"
          name=""
          value="FINISH"
          onClick={onClick}
        />
      </div>
    </div>
  </div>
)

export default Results;



// WEBPACK FOOTER //
// ./src/components/Quiz/Results.js